export function commaFormatted(number) {
  if (typeof number !== 'number') return number
  return Number(number).toLocaleString()
}
